import type { FC } from "react";
import React, { memo, useMemo } from "react";
import ReactGridLayout, { horizontalCompactor, useContainerWidth } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import ScrollableFlexContainer from "@entrilia/shared/components/ScrollableFlexContainer";
import type { TileObject } from "./models/TileObject";
import "./styles.css";
import { convertTileLocationToLayout } from "./utils/tileLocationUtils";
import TileComponent from "./widgets/TileComponent";
import TileRenderer from "./widgets/TileRenderer";

interface DashboardLayoutProps {
  className?: string;
  rowHeight?: number;
  cols?: number;
  tiles: TileObject[];
}

const CanvasView: FC<DashboardLayoutProps> = ({ className = "run-layout", rowHeight = 1, cols = 24, tiles }) => {
  const { width, containerRef, mounted } = useContainerWidth();
  const layout = useMemo(
    () => tiles?.map((tile) => convertTileLocationToLayout(tile.item.location, tile.id)) ?? [],
    [tiles]
  );

  const generateDOM = useMemo(() => {
    return tiles?.map((tile) => (
      <TileComponent key={tile.id} tile={tile}>
        <TileRenderer tile={tile} />
      </TileComponent>
    ));
  }, [tiles]);

  return (
    <ScrollableFlexContainer containerRef={containerRef}>
      {mounted && (
        <ReactGridLayout
          width={width}
          style={{
            minHeight: "100%",
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
          className={className}
          layout={layout}
          gridConfig={{ cols: cols, rowHeight: rowHeight, margin: [16, 12] }}
          dragConfig={{ enabled: false }}
          dropConfig={{ enabled: false }}
          resizeConfig={{ enabled: false }}
          compactor={horizontalCompactor}
        >
          {generateDOM}
        </ReactGridLayout>
      )}
    </ScrollableFlexContainer>
  );
};

export default memo(CanvasView);
